import type { RouterConfig } from '@nuxt/schema'
import { useRuntimeConfig, useRequestURL } from '#app'

import authRoutes from '~/routes/auth.js'
import adminRoutes from '~/routes/admin.js'
import customerRoutes from '~/routes/customer.js'

export default <RouterConfig>{
    routes: (_routes) => {
        const routesToLoad = useRuntimeConfig().public.build === 'admin' ? adminRoutes : customerRoutes;

        return [
            ...authRoutes,
            ...routesToLoad
        ]
    },
}
